import { useIntl } from "react-intl";

interface MiniCvPosition {
  id: string;
  title: string;
  year: number;
}

interface MiniCvCompany {
  id: string;
  name: string;
  period: string;
  secondary?: boolean;
  tech: string[];
  positions: MiniCvPosition[];
}

const MINI_CV_RU: MiniCvCompany[] = [
  {
    id: "geropharm",
    name: "ООО Герофарм",
    period: "2015 - н.в.",
    tech: [".NET", "SharePoint", "React"],
    positions: [
      { id: "geropharm-head", title: "Рук. отдела", year: 2021 },
      { id: "geropharm-team-lead", title: "Teamlead", year: 2018 },
      { id: "geropharm-senior", title: "Senior", year: 2016 },
      { id: "geropharm-developer", title: "Middle", year: 2015 },
    ],
  },
  {
    id: "ittilan",
    name: "ООО Иттилан",
    period: "2012 - 2015",
    tech: [".NET", "SharePoint"],
    positions: [
      { id: "ittilan-senior", title: "Senior", year: 2014 },
      { id: "ittilan-support-dev", title: "Middle", year: 2013 },
      { id: "ittilan-junior-support", title: "Junior", year: 2012 },
    ],
  },
  {
    id: "freelance",
    name: "Фриланс",
    period: "2007 - 2012",
    tech: ["PHP", "jQuery"],
    positions: [],
    secondary: true,
  },
];

const MINI_CV_EN: MiniCvCompany[] = [
  {
    id: "geropharm",
    name: "Geropharm",
    period: "2015 - Present",
    tech: [".NET", "SharePoint", "React"],
    positions: [
      { id: "geropharm-head", title: "Head of Dev", year: 2021 },
      { id: "geropharm-team-lead", title: "Teamlead", year: 2018 },
      { id: "geropharm-senior", title: "Senior", year: 2016 },
      { id: "geropharm-developer", title: "Middle", year: 2015 },
    ],
  },
  {
    id: "ittilan",
    name: "Ittilan",
    period: "2012 - 2015",
    tech: [".NET", "SharePoint"],
    positions: [
      { id: "ittilan-senior", title: "Senior", year: 2014 },
      { id: "ittilan-support-dev", title: "Middle", year: 2013 },
      { id: "ittilan-junior-support", title: "Junior", year: 2012 },
    ],
  },
  {
    id: "freelance",
    name: "Freelance",
    period: "2007 - 2012",
    tech: ["PHP", "jQuery"],
    positions: [],
    secondary: true,
  },
];

const useMiniCvData = (): MiniCvCompany[] => {
  const { locale } = useIntl();
  const short = locale.split("-")[0];
  return short === "ru" ? MINI_CV_RU : MINI_CV_EN;
};

export { useMiniCvData };
export type { MiniCvCompany, MiniCvPosition };
